import {
  garlicShrimp, padronPeppers, charredOctopus, falafelHummus, loadedNachos,
  quesadilla, legendBoard, cheesecake, baklava,
  partyBoard, cheeseBoard, streetFeast, burgerHero, hotdogHero,
  cocktailAperol, cocktailAmericano, cocktailBellini, cocktailBloodyMary,
  cocktailManhattan, cocktailDaiquiri, cocktailMimosa, cocktailOldFashioned,
  cocktailPinaColada, cocktailSexOnBeach, cocktailTequilaSunrise, cocktailWhiskeySour,
  cocktailNegroni, cocktailDirtyMartini, cocktailDryMartini, cocktailEspressoMartini,
  cocktailFrench75, cocktailFrozenDaiquiri, cocktailLongIsland, cocktailLynchburg,
  cocktailCosmopolitan,
} from '../assets/images'

export const foodMenu = [
  {
    id: 'sharing-bites',
    category: 'Sharing Bites',
    note: 'Perfect for cocktails, sharing and social dining.',
    items: [
      { name: 'Halloumi Fries',       price: 8.00,  desc: 'Crispy halloumi fries, hot honey, sesame.' },
      { name: 'Patatas Bravas',       price: 7.00,  desc: 'Crispy potatoes, brava sauce, garlic aioli.' },
      { name: 'Padron Peppers',       price: 7.00,  desc: 'Blistered Spanish peppers, sea salt.', image: padronPeppers },
      { name: 'Garlic Shrimp',        price: 12.00, desc: 'Sautéed shrimp, garlic, olive oil, parsley.', image: garlicShrimp },
      { name: 'Crispy Anchovies',     price: 9.00,  desc: 'Lightly fried anchovies, lemon wedge.' },
      { name: 'Crispy Chicken Bites', price: 9.00,  desc: 'Golden crispy chicken bites with house dip.' },
      { name: 'Truffle Parmesan Fries', price: 7.00, desc: 'Crispy fries, truffle oil, shaved parmesan, fresh herbs.' },
    ],
  },
  {
    id: 'goat-favorites',
    category: 'GOAT Favorites',
    items: [
      { name: 'Charred Octopus',    price: 14.00, desc: 'Grilled octopus, Mediterranean herbs, lemon dressing.', image: charredOctopus },
      { name: 'Falafel & Hummus',   price: 9.00,  desc: 'Five crispy falafels served on creamy hummus.', image: falafelHummus },
      { name: 'Loaded Nachos',      price: 11.00, desc: 'Cheese sauce, guacamole, jalapeños, pico de gallo, sour cream.', image: loadedNachos },
      { name: 'GOAT Sliders Board', price: 16.00, desc: 'Four mini beef sliders, loaded nachos, house dips.' },
      { name: 'GOAT Legend Board',  price: 39.00, desc: 'The full spread for four — octopus, shrimp, mezze & more.', badge: 'For 4', image: legendBoard },
    ],
  },
  {
    id: 'boards-to-share',
    category: 'Boards to Share',
    note: 'Designed for sharing. Made for good times.',
    items: [
      { name: 'Mediterranean Cheese Board', price: 24.00, desc: 'Selection of Mediterranean cheeses, fruits, crackers, olives and preserves.', image: cheeseBoard },
      { name: 'GOAT Party Board',           price: 29.00, desc: 'Hummus, muhammara, halloumi fries, falafel, crispy anchovies, chicken bites, loaded nachos.', badge: 'For 2', image: partyBoard },
      { name: 'GOAT Street Feast',          price: 24.00, desc: '2 crispy beef tacos, 2 crispy chicken tacos, 2 crispy döner rolls, mini cheese quesadilla, guacamole, salsa roja.', image: streetFeast },
    ],
  },
  {
    id: 'quesadillas',
    category: 'Quesadillas',
    items: [
      { name: 'GOAT Steak Quesadilla',   price: 12.90, desc: 'Crispy grilled tortilla, marinated beef strips, mozzarella, guacamole, pico de gallo, sour cream.', image: quesadilla },
      { name: 'GOAT Chicken Quesadilla', price: 11.90, desc: 'Crispy grilled tortilla, marinated chicken, mozzarella, guacamole, pico de gallo, sour cream.', image: quesadilla },
    ],
  },
  {
    id: 'tacos',
    category: 'Tacos',
    items: [
      { name: 'GOAT Steak Tacos',   price: 9.90, desc: 'Three soft tortillas, marinated beef strips, guacamole, pico de gallo, cheese, sour cream.' },
      { name: 'GOAT Chicken Tacos', price: 8.90, desc: 'Three soft tortillas, marinated chicken, guacamole, pico de gallo, mozzarella, sour cream.' },
    ],
  },
  {
    id: 'burgers',
    category: 'Burgers',
    note: 'All burgers are served with crispy fries.',
    headerImage: burgerHero,
    items: [
      { name: 'GOAT Classic', price: 9.90,  desc: '100g beef patty, cheddar cheese, caramelized onion, pickle relish, truffle mayo.' },
      { name: 'GOAT Edition', price: 10.90, desc: '100g beef patty, caramelized onion, pickle relish, truffle mayo, crispy bacon.' },
      { name: 'B.I.G',        price: 13.90, desc: '200g beef patty, double cheddar, caramelized onion, pickle relish, Jack Daniel\'s mustard sauce, truffle mayo.' },
      { name: 'Fake Mac',     price: 10.90, desc: '100g beef patty, mac sauce, cheddar cheese, caramelized onion, lettuce.' },
    ],
  },
  {
    id: 'hot-dogs',
    category: 'Gourmet Hot Dogs',
    headerImage: hotdogHero,
    items: [
      { name: 'Frankfurter',          price: 9.90,  desc: 'Caramelized onion, herb remoulade, cheddar cheese, honey mustard, cucumber relish.' },
      { name: 'Hermosillo "DOGO"',    price: 10.90, desc: 'Jalapeños, cheddar cheese, avocado aioli, herb remoulade, salsa fresca, pickle relish, honey mustard.' },
    ],
  },
  {
    id: 'sweet-endings',
    category: 'Sweet Endings',
    items: [
      { name: 'Churros',              price: 7.50,  desc: 'Crispy churros with chocolate dipping sauce and dulce de leche.' },
      { name: 'Cheesecake Bites',     price: 7.00,  desc: 'Mini cheesecake bites, berry compote, whipped cream.', image: cheesecake },
      { name: 'Chocolate Fondant',    price: 8.50,  desc: 'Warm chocolate fondant, vanilla gelato, sea salt.' },
      { name: 'Pistachio Baklava',    price: 7.00,  desc: 'Layers of crisp pastry, pistachio, honey syrup.', image: baklava },
    ],
  },
]

export const drinksMenu = [
  {
    id: 'signature-cocktails',
    category: 'Signature Cocktails',
    items: [
      { name: 'The G.O.A.T.',  price: 10.50, desc: 'Sorrel mix, lime juice, gin, orange liqueur. Earthy, citrusy, bitter finish.' },
      { name: 'Red Handed',    price: 10.50, desc: 'Strawberry purée, honey syrup, lime juice, vodka, orange liqueur, mint. Fresh, fruity, clean mint finish.' },
      { name: 'The Sting',     price: 10.50, desc: 'Ginger mix, pineapple juice, vanilla, passion fruit, vodka. Tropical, warm spice, soft finish.' },
      { name: 'Smoky Mule',    price: 10.50, desc: 'Mezcal, ginger beer, lime, agave, smoked salt rim. Bold, smoky, refreshing.' },
      { name: 'Mediterranean Mist', price: 10.50, desc: 'Limoncello, elderflower, prosecco, cucumber, basil. Light, floral, effervescent.' },
    ],
  },
  {
    id: 'classic-cocktails',
    category: 'Classic Cocktails',
    type: 'grid',
    items: [
      { name: 'Aperol Spritz',       price: 8.50, icon: cocktailAperol },
      { name: 'Americano',           price: 8.50, icon: cocktailAmericano },
      { name: 'Bellini',             price: 8.50, icon: cocktailBellini },
      { name: 'Bloody Mary',         price: 8.50, icon: cocktailBloodyMary },
      { name: 'Daiquiri',            price: 8.50, icon: cocktailDaiquiri },
      { name: 'Mimosa',              price: 8.50, icon: cocktailMimosa },
      { name: 'Old Fashioned',       price: 8.50, icon: cocktailOldFashioned },
      { name: 'Pina Colada',         price: 8.50, icon: cocktailPinaColada },
      { name: 'Sex on the Beach',    price: 8.50, icon: cocktailSexOnBeach },
      { name: 'Tequila Sunrise',     price: 8.50, icon: cocktailTequilaSunrise },
      { name: 'Whiskey Sour',        price: 8.50, icon: cocktailWhiskeySour },
      { name: 'Manhattan',           price: 9.50, icon: cocktailManhattan },
      { name: 'Classic Negroni',     price: 9.50, icon: cocktailNegroni },
      { name: 'Cosmopolitan',        price: 9.50, icon: cocktailCosmopolitan },
      { name: 'Dirty Martini',       price: 9.50, icon: cocktailDirtyMartini },
      { name: 'Dry Martini',         price: 9.50, icon: cocktailDryMartini },
      { name: 'Espresso Martini',    price: 9.50, icon: cocktailEspressoMartini },
      { name: 'French 75',           price: 9.50, icon: cocktailFrench75 },
      { name: 'Frozen Daiquiri',     price: 9.50, icon: cocktailFrozenDaiquiri },
      { name: 'Long Island Ice Tea', price: 9.50, icon: cocktailLongIsland },
      { name: 'Lynchburg Lemonade',  price: 9.50, icon: cocktailLynchburg },
      { name: 'Margarita',           price: 9.50 },
      { name: 'Mojito',              price: 9.50 },
      { name: 'Moscow Mule',         price: 9.50 },
      { name: 'Porn Star Martini',   price: 9.50 },
    ],
  },
  {
    id: 'draught-beer',
    category: 'Draught Beer',
    type: 'draught',
    columns: ['½ Pint', 'Pint'],
    items: [
      { name: 'Cisk',                      halfPint: 3.00, pint: 5.25 },
      { name: 'Cisk Excel',                halfPint: 3.00, pint: 5.25 },
      { name: 'Strongbow Dark Fruit Cider', halfPint: 3.50, pint: 5.50 },
      { name: 'Guinness',                  halfPint: 4.00, pint: 6.00 },
    ],
  },
  {
    id: 'bottle-beer',
    category: 'Bottle Beer',
    items: [
      { name: 'Cisk',                  price: 3.00 },
      { name: 'Cisk Excel',            price: 3.00 },
      { name: 'Heineken',              price: 3.00 },
      { name: 'Heineken Alcohol Free', price: 3.00 },
      { name: 'Budweiser',             price: 3.50 },
      { name: 'Peroni',                price: 3.50 },
      { name: 'Corona',                price: 4.00 },
      { name: 'Corona Alcohol Free',   price: 4.00 },
      { name: 'Green Hop IPA',         price: 4.00 },
      { name: 'Hoegaarden',            price: 4.00 },
      { name: 'Leffe Blonde',          price: 4.00 },
    ],
  },
  {
    id: 'wine',
    category: 'Wine',
    items: [
      { name: 'House White (glass)',   price: 5.50 },
      { name: 'House White (bottle)',  price: 18.00 },
      { name: 'House Rosé (glass)',    price: 5.50 },
      { name: 'House Rosé (bottle)',   price: 18.00 },
      { name: 'House Red (glass)',     price: 5.50 },
      { name: 'House Red (bottle)',    price: 18.00 },
      { name: 'Prosecco (glass)',      price: 6.50 },
      { name: 'Prosecco (bottle)',     price: 22.00 },
    ],
  },
  {
    id: 'soft-drinks',
    category: 'Soft Drinks & Juices',
    items: [
      { name: 'Coke / Diet Coke / Zero', price: 3.00 },
      { name: 'Sprite',                  price: 3.00 },
      { name: 'Fanta',                   price: 3.00 },
      { name: 'Still / Sparkling Water', price: 2.50 },
      { name: 'Fresh Orange Juice',      price: 4.00 },
      { name: 'Red Bull',                price: 4.50 },
    ],
  },
]
